import { createFileRoute } from "@tanstack/react-router";
import { StudyGroupSearch } from "@/features/all-study-groups/components/StudyGroupSearch";

export const Route = createFileRoute("/all-study-groups/")({
  component: StudyGroupSearch,
});
